import getCookie from "swfrontend/COMS/Utils/cookies";
import { BASE_URL, HEADER_JSON } from "../../../App/Configs/AppConfigs";
import { localStorageVariableName } from "swfrontend/AppConfigs";


const MultipartDataUploader = async (
  api,
  formData = null,
  method = "POST",
  token = false,
  fileTask = false,
  ) => {
  const url = `${BASE_URL}${api}`

  if (fileTask) {
    delete HEADER_JSON["Content-Type"]
  }

  const options = {
    method,
    headers: { ...HEADER_JSON, Authorization: JSON.parse(
          localStorage.getItem(`${process.env.REACT_APP_TOKEN_PREFIX}-auth-token`)
        ),
        "X-CSRFToken": getCookie(`${process.env.REACT_APP_TOKEN_PREFIX}-csrftoken`)},
    body: formData,
  };


  try {
    const response = await fetch(url, options);


    const status = response.status;
    const statusText = response.statusText;

    if (!response.ok) {
      const errorData = await response.json();
      console.error(errorData?.message, "Something went wrong");
      return { status, statusText, data: errorData };
    }

    const data = await response.json();

    return {
      data,
      status,
      statusText,
    };
  } catch (error) {
    console.error("Something went wrong");
    return { status: "error", statusText: error.message, data: null };
  }
};

export default MultipartDataUploader;
